import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {resolveConfigFormHref, resolveConfigFormHrefByEventTemplateId} from "~/workspaceConfig/configHref";

export function resolveEventFormCreateHref({
    workspaceId,
    eventTemplateId,
    formId,
}: {
    workspaceId: Uuid;
    eventTemplateId: Uuid;
    formId: Uuid;
}): string {
    const byFormId = resolveConfigFormHref({workspaceId, formId});
    if (byFormId !== null) {
        return byFormId;
    }
    const byTemplate = resolveConfigFormHrefByEventTemplateId({workspaceId, eventTemplateId});
    if (byTemplate !== null) {
        return byTemplate;
    }
    throw new Error(`No config FormPage for form ${formId} in workspace ${workspaceId}`);
}
